import {
  checkAndPerformGraduation,
  getSetCounts,
  getBoxStatus,
} from "@/lib/scheduler";
import { NextRequest, NextResponse } from "next/server";

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId } = body;

    if (!userId) {
      return NextResponse.json(
        { error: "userId is required" },
        { status: 400 }
      );
    }

    // Perform graduation: retire Box 3 cards, add new cards
    const graduationResult = await checkAndPerformGraduation(userId);

    // Get updated counts
    const counts = await getSetCounts(userId);
    const boxStatus = await getBoxStatus(userId);

    const masteryPercent = counts.focusCount > 0
      ? Math.round((counts.focusCorrectCount / counts.focusCount) * 100)
      : 0;

    return NextResponse.json({
      success: true,
      graduated: graduationResult.graduated,
      graduatedCount: graduationResult.graduatedCount,
      newFocusCount: graduationResult.newCardsAdded,
      shakyCardsKept: graduationResult.shakyCardsKept,
      focusCount: counts.focusCount,
      focusCorrectCount: counts.focusCorrectCount,
      masteryPercent,
      newCount: counts.newCount,
      oldCount: counts.oldCount,
      boxStatus,
    });
  } catch (error) {
    console.error("Error performing graduation:", error);
    return NextResponse.json(
      { error: error instanceof Error ? error.message : "Failed to perform graduation" },
      { status: 500 }
    );
  }
}
